import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { REMOVE_AD } from '../../redux/Ads';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

const AdsTableButtonsCell = ({ adId, history, removeAd, t, }) => {
  const classes = useStyles();
  return (
    <td>
      <button
        className="btn blue"
        onClick={(e) => {
          e.stopPropagation();
          history.push(`/dashboard/ads/update/${adId}`);
        }}
      >
        <span>{t('update')}</span>
      </button>
      <button
        className={`btn ${classes.button}`}
        onClick={(e) => {
          e.stopPropagation();
          removeAd(adId);
        }}
      >
        <span>{t('remove')}</span>
      </button>
    </td>
  );
};

const useStyles = createUseStyles({
  button: {
    marginTop: '1em',
    backgroundColor: '#ec8282',
    color: 'white',
    '&:hover': {
      color: 'white',
      border: '1px solid red',
    },
  },
});

AdsTableButtonsCell.propTypes = {
  adId: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  removeAd: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    removeAd: (adId) => dispatch(REMOVE_AD(adId)),
  };
};

export default compose(
  connect(null, mapDispatchToProps),
  withRouter,
  withScopedTranslations('ads.buttons_cell')
  )(AdsTableButtonsCell);
